import { ofType } from 'redux-observable'
import { switchMap, map, takeUntil, tap } from 'rxjs/operators'
import { ajax } from 'rxjs/ajax'
// import { ajax } from 'Utils'
// import { ajax as chatAjax } from 'Utils'
import { LOGIN, REQUEST_CANCEL, LOG_OUT, VERIFY_PIN, SMS_LOGIN, CLINIC_DATA } from './login.types'
import { loginResponse, checkPinResponse, smsLoginResponse, clinicResponse } from './login.actions'
import environment from 'environments/environment'
const baseUrl = environment.baseUrl;

const loginEpic = {}

/**
 * @fileOverview Manages the APIs w.r.t action in the redux
 * @author Athul George <athul@trillium-technologies.com>
 * @author  Akhil Francis <akhil@trillium-technologies.com>
 * @author Cinu James <cinu@trillium-technologies.com>

/**
 * Login
 * @description Calling the login API for a user to login
 * @param action$
 */



loginEpic.verifyPin = (action$) =>
  action$.pipe(
    ofType(VERIFY_PIN),
    switchMap((action) =>
      ajax({
        headers: { 'Content-Type': 'application/json' },
        url: `${baseUrl}/trillium-patient-service/v1/authenticate/${action.payload}`,
        method: 'GET',
      }).pipe(
        map((response) => {
          // store response in sessionStorage
          sessionStorage.setItem('clinicId',response?.response?.data?.clinicId); 
          sessionStorage.setItem('clinicName',response?.response?.data?.clinicName);
          // dispatch action to Redux
          return checkPinResponse(response.response);
        }),
        takeUntil(action$.pipe(ofType(REQUEST_CANCEL)))
      )
    )
  );


loginEpic.login = (action$) =>
  action$.pipe(
    ofType(LOGIN),
    switchMap((action) =>
      ajax({
        headers: { "Content-Type": "application/json" },
        url: `${baseUrl}/trillium-patient-service/v2/patient/login`,
        method: "POST",
        body: JSON.stringify(action.payload),
      }).pipe(
        tap((response) => {
          if (response?.response?.data?.accessToken) {
            // sessionStorage.removeItem("pin"); (commented out by sumesh on 11-09-2025 as per new requirement)
          }
        }),
        map((response) => loginResponse(response)),
        takeUntil(action$.pipe(ofType(REQUEST_CANCEL)))
      )
    )
  );
loginEpic.clinic = (action$) =>
  action$.pipe(
    ofType(CLINIC_DATA),
    switchMap((action) =>
      ajax({
        headers: { 'Content-Type': 'application/json' },
        url: `${baseUrl}/trillium-patient-service/clinic-logo`,
        method: 'POST',
        body: JSON.stringify(action.payload),
      }).pipe(
        tap((response) => {
          const clinicLogo = response?.response?.data?.clinicLogo
          if (clinicLogo) {
            sessionStorage.setItem('clinicLogo')
          }
        }),
        map((response) => clinicResponse(response)),
        takeUntil(action$.pipe(ofType(REQUEST_CANCEL))),
      ),
    ),
  )
loginEpic.logOut = (action$) =>
  action$.pipe(
    ofType(LOG_OUT),
    switchMap(() =>
      ajax({
        headers: { 'Content-Type': 'application/json' },
        url: `${baseUrl}/patient-portal-api/v1/patient/logout`,
        method: 'POST',
        // body: JSON.stringify(action.payload),
      }).pipe(
        map(
          (response) => loginResponse(response),
          takeUntil(action$.pipe(ofType(REQUEST_CANCEL))),
        ),
      ),
    ),
  )

loginEpic.smsLogin = (action$) =>
  action$.pipe(
    ofType(SMS_LOGIN),
    switchMap((action) =>
      ajax({
        headers: { 'Content-Type': 'application/json' },
        // url: `/patient-portal-api/patient/login`,
        url: `${baseUrl}/patient-portal-api/v1/patient/login`,
        method: 'POST',
        body: JSON.stringify(action.payload),
      }).pipe(
        map(
          (response) => smsLoginResponse(response),
          takeUntil(action$.pipe(ofType(REQUEST_CANCEL))),
        ),
      ),
    ),
  )

export default loginEpic
